import PropTypes from 'prop-types';
import { Button, Modal, ModalBody } from 'reactstrap';
import ModalCloseButton from '../../components/ModalCloseButton/ModalCloseButton';

export const DiscoveryBelmondEmailNotValidModal = ({ onToggle, isOpen }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onToggle}
      style={{ maxWidth: '600px' }}
      centered
      external={
        <ModalCloseButton onClose={onToggle} className="modalCloseButton" />
      }
    >
      <ModalBody className="d-flex flex-column align-items-center">
        <div className="my-4">The email is invalid, please contact your HR</div>
        <Button onClick={onToggle} className="button">
          Refresh Page
        </Button>
      </ModalBody>
    </Modal>
  );
};

DiscoveryBelmondEmailNotValidModal.propTypes = {
  onToggle: PropTypes.func,
  isOpen: PropTypes.bool,
};
